/**
 * TriviaChoice.id is only unique within a question. Duplicate ids across
 * questions (imports/API) must not collapse in the normalized cache.
 */
export const apolloTypePolicies = {
  TriviaChoice: {
    keyFields: false as const,
  },
};
